import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Deactivate the animation for now
export default class KeyData {
  constructor(container) {
    return;
    console.log("KeyData: Constructor called with container:", container);

    this.DOM = { container };
    this.DOM.numbers = this.DOM.container.querySelectorAll(
      ".key-datas--item em"
    );

    console.log("KeyData: Found elements:", this.DOM.numbers);

    if (!this.DOM.numbers || !this.DOM.numbers.length) {
      console.warn("KeyData: No strong elements found in .key-datas--item");
      return;
    }

    console.log("KeyData: Found", this.DOM.numbers.length, "numbers");
    this.prepareNumbers();
    this.incrementNumbersOnScroll();
  }

  prepareNumbers() {
    // Extract numbers from text content and store them
    this.DOM.numbers.forEach((number) => {
      const text = number.textContent.trim();
      const numericValue = text.match(/[\d,.]+/)?.[0];

      if (numericValue) {
        // Store the original number
        number.dataset.number = numericValue;
        // Store any prefix/suffix
        const parts = text.split(numericValue);
        number.dataset.prefix = parts[0] || "";
        number.dataset.suffix = parts[1] || "";

        // Set initial value to 0 immediately
        number.textContent = (parts[0] || "") + "0" + (parts[1] || "");

        console.log(
          "KeyData: Prepared number",
          numericValue,
          "with prefix:",
          parts[0],
          "suffix:",
          parts[1]
        );
      }
    });
  }

  incrementNumbersOnScroll() {
    console.log("KeyData: Setting up ScrollTrigger");
    const { container } = this.DOM;

    this.ST = ScrollTrigger.create({
      trigger: container,
      start: "top center+=100",
      end: "bottom top",
      markers: false,
      once: true,
      onEnter: () => {
        console.log("KeyData: ScrollTrigger activated");
        this.animateNumbers();
      },
    });
  }

  animateNumbers() {
    this.DOM.numbers.forEach((number) => {
      const targetValue = number.dataset.number;
      const prefix = number.dataset.prefix || "";
      const suffix = number.dataset.suffix || "";

      if (!targetValue) return;

      // Clean the number (remove spaces and commas for calculation)
      const cleanTarget = parseFloat(targetValue.replace(/[,\s]/g, ""));

      if (isNaN(cleanTarget)) {
        console.warn("KeyData: Invalid number", targetValue);
        return;
      }

      const numberObj = { value: 0 };

      gsap.to(numberObj, {
        value: cleanTarget,
        duration: 1.5,
        ease: "power4.inOut",
        onUpdate: () => {
          // Format the number to match original formatting
          let formattedValue = Math.round(numberObj.value);

          // Add spaces for thousands if original had them
          if (targetValue.includes(" ")) {
            formattedValue = formattedValue
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          } else if (targetValue.includes(",")) {
            formattedValue = formattedValue
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }

          number.textContent = prefix + formattedValue + suffix;
        },
      });
    });
  }

  destroy() {
    this.ST && this.ST.kill();
  }
}
